import SampleCollection from './SampleCollection';
export default SampleCollection;